/**
 * @velyn-custom — vely-card-product.js
 * For .vely-card-product only: route swatch AJAX to section vely-card-product
 * so price + badges stay on the same active variant. Does not edit Core files.
 */
(function () {
  const SECTION_ID = 'vely-card-product';
  const PATCH_FLAG = '_velyCardProductPatched';

  function isVelyCard(node) {
    return Boolean(
      node &&
        (node.classList?.contains('vely-card-product') ||
          node.closest?.('.vely-card-product'))
    );
  }

  function syncCardVariantId(card, html) {
    const jsonEl = html.querySelector('.productVariantSelected');
    if (!jsonEl) return;
    try {
      const variant = JSON.parse(jsonEl.textContent);
      const variantId = variant && variant.id ? String(variant.id) : '';
      if (!variantId) return;
      card.querySelectorAll('product-form input[name="id"], .quick-add input[name="id"]').forEach((input) => {
        input.value = variantId;
        if (variant.available === false) {
          const btn = input.closest('product-form')?.querySelector('[type="submit"], [name="add"]');
          if (btn) btn.disabled = true;
        } else {
          input.disabled = false;
          const btn = input.closest('product-form')?.querySelector('[type="submit"], [name="add"]');
          if (btn) btn.disabled = false;
        }
      });
    } catch (_e) {
      /* ignore malformed JSON */
    }
  }

  function createVelyResponsiveProduct(productUrl, currentProduct, position) {
    const card = currentProduct.classList.contains('vely-card-product')
      ? currentProduct
      : currentProduct.closest('.vely-card-product');
    if (!card) return;

    if (this._velyCardAbort) this._velyCardAbort.abort();
    this._velyCardAbort = new AbortController();
    const token = (this._velyCardRequestToken = (this._velyCardRequestToken || 0) + 1);

    const url = `${productUrl}&section_id=${SECTION_ID}`;
    fetch(url, { signal: this._velyCardAbort.signal })
      .then((response) => response.text())
      .then(async (responseText) => {
        if (token !== this._velyCardRequestToken) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const currentImage = card.querySelector('.featured-image');
        const newImage = html.querySelector('.featured-image');
        const secondaryImage = card.querySelector('.product__hover-img');
        if (secondaryImage) secondaryImage.classList.remove('hidden');

        const currentPrice = card.querySelector('.product__price');
        const newPrice = html.querySelector('.product__price');
        if (currentPrice && newPrice) currentPrice.replaceWith(newPrice);

        const currentBadges = card.querySelector('.product__badges');
        const newBadges = html.querySelector('.product__badges');
        if (currentBadges && newBadges) {
          currentBadges.replaceWith(newBadges);
        } else if (currentBadges && !newBadges) {
          currentBadges.remove();
        } else if (!currentBadges && newBadges) {
          const mediaLink = card.querySelector('a.product-image, a.vely-card-product__media');
          if (mediaLink) mediaLink.appendChild(newBadges);
        }

        const currentQuickAdd = card.querySelector('.variant-quick-add-js');
        const newQuickAdd = html.querySelector('.variant-quick-add-js');
        if (currentQuickAdd && newQuickAdd) {
          currentQuickAdd.replaceWith(newQuickAdd);
          card.querySelector('quick-add')?.classList.remove('active');
        }

        syncCardVariantId(card, html);

        if (currentImage && newImage && currentImage.src !== newImage.src) {
          if (window.Motion?.animate) {
            await Motion.animate(
              currentImage,
              { opacity: [1, 0] },
              { duration: 0.1, easing: 'ease-in', fill: 'forwards' }
            ).finished;
            await new Promise((resolve) =>
              newImage.complete ? resolve() : (newImage.onload = resolve)
            );
            currentImage.replaceWith(newImage);
            Motion.animate(newImage, { opacity: [0, 1] }, { duration: 0.1, easing: 'ease-in' });
          } else {
            currentImage.replaceWith(newImage);
          }
        }
      })
      .catch((e) => {
        if (e?.name === 'AbortError') return;
        console.error('Vely card variant update failed:', e);
      });
  }

  function patchVariantInput() {
    const Ctor = customElements.get('variant-input');
    if (!Ctor || Ctor.prototype[PATCH_FLAG]) return Boolean(Ctor);

    const original = Ctor.prototype.createResponsiveProduct;
    if (typeof original !== 'function') return true;

    Ctor.prototype.createResponsiveProduct = function (productUrl, currentProduct, position) {
      if (isVelyCard(currentProduct)) {
        return createVelyResponsiveProduct.call(this, productUrl, currentProduct, position);
      }
      return original.call(this, productUrl, currentProduct, position);
    };
    Ctor.prototype[PATCH_FLAG] = true;
    return true;
  }

  function boot() {
    if (patchVariantInput()) return;
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (patchVariantInput() || attempts > 40) clearInterval(timer);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
